<template>
  <div>
    <div class="content-quiz">
      <h3 class="has-text-weight-semibold">
        {{ index + 1 }} - {{ questionForm.title }}
        <span v-if="isMultipleSelect">
          <i>({{ $t("ONLINE_TRAINING.DETAIL_QUIZ.NOTE_MULTIPLE") }})</i>
        </span>
      </h3>
      <div class="image-answers" v-if="questionForm.image">
        <img width="80vw" height="100" :src="questionForm.image" :alt="questionForm.title" />
      </div>

      <li v-for="answer in questionForm.answers" :key="answer._id">
        <b-radio
          v-if="!isMultipleSelect"
          :disabled="disabled"
          :name="questionForm.title"
          :native-value="answer._id"
          v-model="selected"
          :class="answer.class_name"
          :type="
            questionForm.is_correct_answer === undefined
              ? 'is-warning'
              : questionForm.is_correct_answer
              ? 'is-success'
              : 'is-danger'
          "
        >
          <article class="media">
            <figure class="media-left">
              <p class="image is-24x24">
                <b-icon
                  v-if="
                    questionForm.is_correct_answer !== undefined &&
                      answer.is_correct
                  "
                  class="has-text-success"
                  icon="checkbox-marked-circle-outline"
                ></b-icon>
                <b-icon
                  v-else-if="
                    questionForm.is_correct_answer !== undefined &&
                      !answer.is_correct &&
                      selected === answer._id
                  "
                  class="has-text-danger"
                  icon="close-circle-outline"
                ></b-icon>
                <b-icon
                  v-else-if="
                    questionForm.is_correct_answer === undefined &&
                      selected === answer._id
                  "
                  icon="radiobox-marked"
                  class="has-text-warning"
                ></b-icon>
                <b-icon v-else icon="radiobox-blank"></b-icon>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">{{ answer.title }}</div>
            </div>
          </article>
        </b-radio>

        <b-checkbox
          v-else
          :disabled="disabled"
          :native-value="answer._id"
          :class="answer.class_name"
          v-model="selected"
          :type="
            questionForm.is_correct_answer === undefined
              ? 'is-warning'
              : questionForm.is_correct_answer
              ? 'is-success'
              : 'is-danger'
          "
        >
          <article class="media">
            <figure class="media-left">
              <p class="image is-24x24">
                <b-icon
                  v-if="
                    questionForm.is_correct_answer !== undefined &&
                      answer.is_correct
                  "
                  class="has-text-success"
                  icon="checkbox-marked-outline"
                ></b-icon>
                <b-icon
                  v-else-if="
                    questionForm.is_correct_answer !== undefined &&
                      !answer.is_correct &&
                      selected.includes(answer._id)
                  "
                  class="has-text-danger"
                  icon="close-box-outline"
                ></b-icon>
                <b-icon
                  v-else-if="
                    questionForm.is_correct_answer === undefined &&
                      selected.includes(answer._id)
                  "
                  icon="checkbox-marked"
                  class="has-text-warning"
                ></b-icon>
                <b-icon v-else icon="checkbox-blank-outline"></b-icon>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">{{ answer.title }}</div>
            </div>
          </article>
        </b-checkbox>
      </li>
    </div>
    <div class="tips" v-if="disabled && question.tip !== ''">
      <article class="media">
        <figure class="media-left">
          <p class="image is-24x24">
            <img src="/img/online-training/tips.svg" />
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <b>{{ $t("ONLINE_TRAINING.DETAIL_QUIZ.TIPS") }}:</b>
              {{ question.tip }}
            </p>
          </div>
        </div>
      </article>
    </div>

    <div class="submit_quiz" v-if="!disabled">
      <b-button
        :class="
          !isMultipleSelect && selected
            ? 'selected'
            : isMultipleSelect && selected && selected.length > 0
            ? 'selected'
            : ''
        "
        @click="submit"
      >{{ $t("ONLINE_TRAINING.DETAIL_QUIZ.BUTTON_CONFIRM") }}</b-button>
    </div>

    <hr />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    question: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["quizzes", "answers"]),
    ...mapState({
      dataQuiz: state => state.course.dataQuiz
    }),
    isMultipleSelect() {
      // 1: single select, 2: multiple select
      return this.question.type === 2;
    },
    disabled: {
      cache: false,
      get() {
        return (
          this.questionForm && this.questionForm.is_correct_answer !== undefined
        );
      }
    }
  },

  data() {
    return {
      message: "",
      questionForm: {},
      selected: null,
      alert_success: "Bạn đã trả lời đúng",
      alert_fail: "Bạn đã trả lời sai!",
      alert_warning: "Chọn 1 đáp án sau đó ấn 'XÁC NHẬN' "
    };
  },

  methods: {
    submit() {
      if (!this.selected) return;

      if (!this.isMultipleSelect) {
        let isCorrectAnswer = false;

        this.questionForm.answers.forEach(answer => {
          if (answer._id === this.selected) {
            answer.selected = true;

            if (answer.is_correct) {
              answer.is_true = true;
              isCorrectAnswer = true;
            }
            answer.class_name = answer.is_correct
              ? "text-correct"
              : "text-wrong";
          } else if (answer.is_correct) {
            answer.class_name = "text-correct";
          }
        });
        this.questionForm.is_correct_answer = isCorrectAnswer;
      } else {
        let numOfCorrectedAnswer = [];
        this.questionForm.answers.forEach(answer => {
          if (answer.is_correct) {
            numOfCorrectedAnswer.push(answer._id);
            answer.is_true = true;
            answer.class_name = "text-correct";
          }

          if (this.selected.indexOf(answer._id) > -1) {
            answer.selected = true;
            if (!answer.is_correct) {
              answer.class_name = "text-wrong";
            }
          }
        });

        this.questionForm.is_correct_answer =
          numOfCorrectedAnswer.length === this.selected.length;
        if (this.questionForm.is_correct_answer) {
          numOfCorrectedAnswer.forEach(value => {
            if (this.selected.indexOf(value) === -1) {
              this.questionForm.is_correct_answer = false;
            }
          });
        }
      }

      this.$emit("onSubmit", this.questionForm);

      if (this.questionForm.is_correct_answer) {
        this.$store.dispatch("addScore");
        this.$buefy.notification.open({
          message: this.alert_success,
          type: "is-success",
          duration: 1500,
          position: "is-bottom"
        });
      } else {
        this.$buefy.notification.open({
          message: this.alert_fail,
          type: "is-danger",
          duration: 1500,
          position: "is-bottom"
        });
      }
      this.$forceUpdate();
    }
  },
  mounted() {
    this.questionForm = this.question;
    if (this.isMultipleSelect) {
      this.selected = [];
    }

    // set scrollTop = 0
    var y = window.scrollY;
    if (y > 0) {
      window.scroll(0, 0);
    }
  }
};
</script>
<style lang="scss">
hr {
  margin: 1.5rem 0 0 0;
}
.notification.is-danger {
  background-color: #d44632;
}
.notification.is-success {
  background-color: #1dc05e;
}
.text-wrong {
  color: #d44632 !important;
}
.text-correct {
  color: #1dc05e !important;
}
.content-quiz {
  padding: 20px;
  border-radius: 5px;

  .image-answers {
    width: 100%;
    background-color: #eaeaea;
    text-align: center;
    margin-bottom: 10px;
    img {
      width: 35%;
    }
  }

  h3 {
    margin-bottom: 15px;
  }
  li {
    padding: 7px 0;
    .radio,
    .checkbox {
      .control-label {
        display: flex;
      }
      span.check {
        display: none !important;
      }
    }
  }
}
.tips,
.submit_quiz {
  padding: 5px 20px;
}

.tips {
  .media-left {
    margin-right: 8px;
  }
}

.submit_quiz {
  button {
    font-size: 14px;
    width: 100px;
    height: 40px;
    background-color: #bcbcbc;
    color: white;

    &:hover {
      color: #fff;
    }
  }
  button.selected {
    background-color: #ff8200;
  }
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .content-quiz{
    .image-answers {
      img {
        width: 100%;
      }
    }
  }
}
</style>
